import { render, staticRenderFns } from "./se2a-qualification-plan-detail.vue?vue&type=template&id=5867f96a&scoped=true"
import script from "./se2a-qualification-plan-detail.vue?vue&type=script&lang=js"
export * from "./se2a-qualification-plan-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5867f96a",
  null
  
)

export default component.exports